import { createAsyncThunk } from '@reduxjs/toolkit';
import sliceConstants from './manageUsersSectionSliceConstants';

const extraActions = {};

export default extraActions;
